export default [
  {
    path: '/algoritmos/balanceamento/regras',
    name: 'ambience-balance-rules-index',
    // Aponta para o formulário/listagem UNIFICADO (form único superset).
    // A rota antiga (this module's ./pages/RulesIndex) fica só como legado a
    // remover na Fase 3. `algorithmFilter` mantém a listagem filtrada por
    // balanceamento e define o algoritmo default ao criar uma regra nova.
    component: () => import('@/modules/algorithm_rules/pages/RulesIndex'),
    props: { algorithmFilter: 'ambience_balance' },
    meta: {
      title: 'Regras de balanceamento',
      icon: 'mdi-ruler-square-compass',
      breadcrumbs: [
        { text: 'Algoritmos', disabled: true, href: '/' },
        { text: 'Balanceamento', disabled: true, href: '/' },
        { text: 'Regras', disabled: true, href: '/' },
      ],
    },
  },
]
